import React, { useState } from 'react';
import i18n from '@nextroll/ar-i18n';
import classNames from 'classnames';

import { InputGroup } from '@nextroll/ar-style-base';

interface IProps {
    name: string;
    onUpdateName: (name: string) => void;
}

export const EditableName = ({ name, onUpdateName }: IProps) => {
    const [editingName, setEditingName] = useState(undefined as string | undefined);

    const onEditNameStart = () => setEditingName(name);

    const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => setEditingName(e.target.value);

    const onNameChangeConfirm = () => {
        if (editingName) {
            onUpdateName(editingName.trim() || name);
        }
        setEditingName(undefined);
    };

    const onNameChangeCancel = () => setEditingName(undefined);

    const editableNameClassnames = classNames('editable-name-header', {
        'truncate-editable-name-width': true,
    });

    return (
        <div className={editableNameClassnames}>
            {editingName || editingName === '' ? (
                <>
                    <InputGroup
                        i18n={i18n.noop}
                        validationState={name === '' ? InputGroup.VALIDATION_ERROR : undefined}
                        classNames='editable-name-input'
                        inputProps={{
                            id: 'name-input',
                            onChange: onNameChange,
                            value: editingName,
                            maxLength: 200,
                            autoFocus: true,
                            onKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => {
                                if (event.key === 'Enter' && name !== '') {
                                    onNameChangeConfirm();
                                }
                            },
                        }}
                    />
                    <i className='fa fa-check editable-name-edit-icon' aria-label='Confirm edit' onClick={onNameChangeConfirm} />
                    <i className='fa fa-times editable-name-edit-icon' aria-label='Cancel edit' onClick={onNameChangeCancel} />
                </>
            ) : (
                <>
                    <h1>{name}</h1>
                    <i className='fa fa-pen editable-name-edit-icon' aria-label='Edit text' onClick={onEditNameStart} />
                </>
            )}
        </div>
    );
};
